import React, { useContext, useState } from 'react';
import axios from 'axios';
import AuthContext from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

export default function UploadClip() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!user) {
    return (
      <div className="container my-5">
        <h2 className="text-success">Klip Yükle</h2>
        <p>Video yüklemek için giriş yapın.</p>
      </div>
    );
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert('Bir video seçin.');

    const form = new FormData();
    form.append('video', file);
    form.append('title', title);

    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/community/upload`, form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Klip yüklendi!');
      navigate('/community');
    } catch (e) {
      console.error(e);
      alert('Klip yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5" style={{ maxWidth: 640 }}>
      <h2 className="text-success mb-3">Klip Yükle</h2>
      <form onSubmit={onSubmit}>
        <div className="mb-3">
          <label className="form-label">Başlık (opsiyonel)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Örn: Gol pozisyonu 67:12"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            maxLength={120}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Video dosyası</label>
          <input
            type="file"
            className="form-control"
            accept="video/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
          <div className="form-text">Destek: MP4, MOV, MKV (maks. 1 GB)</div>
        </div>
        <button className="btn btn-success" type="submit" disabled={loading}>
          {loading ? 'Yükleniyor...' : 'Yükle'}
        </button>
      </form>
    </div>
  );
}
